import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaPlus, FaEdit, FaUserCheck, FaUserTimes, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import colaboradoresService from '../../services/colaboradoresService';
import '../../styles/pages/RRHH/ColaboradoresPage.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Página de gestión de Colaboradores (Empleados)
 * Preparada para uso manual y por agentes MCP
 */
const ColaboradoresPage = ({ token, id_company }) => {
    const [colaboradores, setColaboradores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtroEstado, setFiltroEstado] = useState('ACTIVO');
    const [showModal, setShowModal] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [colaboradorActual, setColaboradorActual] = useState(null);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const pdfInputRef = React.createRef();

    // Estado para guardar el PDF original cuando se carga desde PDF
    const [pdfOriginalFile, setPdfOriginalFile] = useState(null);

    // Regiones y comunas de Chile
    const regionesComunas = {
        'Región de Arica y Parinacota': ['Arica', 'Camarones', 'General Lagos', 'Putre'],
        'Región de Tarapacá': ['Alto Hospicio', 'Camiña', 'Colchane', 'Huara', 'Iquique', 'Pica', 'Pozo Almonte'],
        'Región de Antofagasta': ['Antofagasta', 'Calama', 'María Elena', 'Mejillones', 'Ollagüe', 'San Pedro de Atacama', 'Sierra Gorda', 'Taltal', 'Tocopilla'],
        'Región de Atacama': ['Alto del Carmen', 'Caldera', 'Chañaral', 'Copiapó', 'Diego de Almagro', 'Freirina', 'Huasco', 'Tierra Amarilla', 'Vallenar'],
        'Región de Coquimbo': ['Andacollo', 'Canela', 'Combarbalá', 'Coquimbo', 'Illapel', 'La Higuera', 'La Serena', 'Los Vilos', 'Monte Patria', 'Ovalle', 'Paiguano', 'Punitaqui', 'Río Hurtado', 'Salamanca', 'Vicuña'],
        'Región de Valparaíso': ['Algarrobo', 'Cabildo', 'Calera', 'Calle Larga', 'Cartagena', 'Casablanca', 'Catemu', 'Concón', 'El Quisco', 'El Tabo', 'Hijuelas', 'Isla de Pascua', 'Juan Fernández', 'La Cruz', 'La Ligua', 'Limache', 'Llaillay', 'Los Andes', 'Nogales', 'Olmué', 'Panquehue', 'Papudo', 'Petorca', 'Puchuncaví', 'Putaendo', 'Quillota', 'Quilpué', 'Quintero', 'Rinconada', 'San Antonio', 'San Esteban', 'San Felipe', 'Santa María', 'Santo Domingo', 'Valparaíso', 'Villa Alemana', 'Viña del Mar', 'Zapallar'],
        'Región Metropolitana': ['Alhué', 'Buin', 'Calera de Tango', 'Cerrillos', 'Cerro Navia', 'Colina', 'Conchalí', 'Curacaví', 'El Bosque', 'El Monte', 'Estación Central', 'Huechuraba', 'Independencia', 'Isla de Maipo', 'La Cisterna', 'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Lampa', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'María Pinto', 'Melipilla', 'Ñuñoa', 'Padre Hurtado', 'Paine', 'Pedro Aguirre Cerda', 'Peñaflor', 'Peñalolén', 'Pirque', 'Providencia', 'Pudahuel', 'Puente Alto', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Bernardo', 'San Joaquín', 'San José de Maipo', 'San Miguel', 'San Pedro', 'San Ramón', 'Santiago', 'Talagante', 'Tiltil', 'Vitacura'],
        'Región del Libertador Gral. Bernardo O\'Higgins': ['Chépica', 'Chimbarongo', 'Codegua', 'Coinco', 'Coltauco', 'Doñihue', 'Graneros', 'La Estrella', 'Las Cabras', 'Litueche', 'Lolol', 'Machalí', 'Malloa', 'Marchihue', 'Nancagua', 'Navidad', 'Olivar', 'Palmilla', 'Paredones', 'Peralillo', 'Peumo', 'Pichidegua', 'Pichilemu', 'Placilla', 'Pumanque', 'Quinta de Tilcoco', 'Rancagua', 'Rengo', 'Requínoa', 'San Fernando', 'San Vicente', 'Santa Cruz'],
        'Región del Maule': ['Cauquenes', 'Chanco', 'Colbún', 'Constitución', 'Curepto', 'Curicó', 'Empedrado', 'Hualañé', 'Licantén', 'Linares', 'Longaví', 'Maule', 'Molina', 'Parral', 'Pelarco', 'Pelluhue', 'Pencahue', 'Rauco', 'Retiro', 'Río Claro', 'Romeral', 'Sagrada Familia', 'San Clemente', 'San Javier', 'San Rafael', 'Talca', 'Teno', 'Vichuquén', 'Villa Alegre', 'Yerbas Buenas'],
        'Región de Ñuble': ['Bulnes', 'Chillán', 'Chillán Viejo', 'Cobquecura', 'Coelemu', 'Coihueco', 'El Carmen', 'Ninhue', 'Ñiquén', 'Pemuco', 'Pinto', 'Portezuelo', 'Quillón', 'Quirihue', 'Ránquil', 'San Carlos', 'San Fabián', 'San Ignacio', 'San Nicolás', 'Treguaco', 'Yungay'],
        'Región del Biobío': ['Alto Biobío', 'Antuco', 'Arauco', 'Cabrero', 'Cañete', 'Chiguayante', 'Concepción', 'Contulmo', 'Coronel', 'Curanilahue', 'Florida', 'Hualpén', 'Hualqui', 'Laja', 'Lebu', 'Los Álamos', 'Los Ángeles', 'Lota', 'Mulchén', 'Nacimiento', 'Negrete', 'Penco', 'Quilaco', 'Quilleco', 'San Pedro de la Paz', 'San Rosendo', 'Santa Bárbara', 'Santa Juana', 'Talcahuano', 'Tirúa', 'Tomé', 'Tucapel', 'Yumbel'],
        'Región de La Araucanía': ['Angol', 'Carahue', 'Cholchol', 'Collipulli', 'Cunco', 'Curacautín', 'Curarrehue', 'Ercilla', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Melipeuco', 'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Purén', 'Renaico', 'Saavedra', 'Temuco', 'Teodoro Schmidt', 'Toltén', 'Traiguén', 'Victoria', 'Vilcún', 'Villarrica'],
        'Región de Los Ríos': ['Corral', 'Futrono', 'La Unión', 'Lago Ranco', 'Lanco', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'Río Bueno', 'Valdivia'],
        'Región de Los Lagos': ['Ancud', 'Calbuco', 'Castro', 'Chaitén', 'Chonchi', 'Cochamó', 'Curaco de Vélez', 'Dalcahue', 'Fresia', 'Frutillar', 'Futaleufú', 'Hualaihué', 'Llanquihue', 'Los Muermos', 'Maullín', 'Osorno', 'Palena', 'Puerto Montt', 'Puerto Octay', 'Puerto Varas', 'Puqueldón', 'Purranque', 'Puyehue', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao', 'Río Negro', 'San Juan de la Costa', 'San Pablo'],
        'Región Aysén del Gral. Carlos Ibáñez del Campo': ['Aysén', 'Chile Chico', 'Cisnes', 'Cochrane', 'Coyhaique', 'Guaitecas', 'Lago Verde', 'O\'Higgins', 'Río Ibáñez', 'Tortel'],
        'Región de Magallanes y de la Antártica Chilena': ['Antártica', 'Cabo de Hornos', 'Laguna Blanca', 'Natales', 'Porvenir', 'Primavera', 'Punta Arenas', 'Río Verde', 'San Gregorio', 'Timaukel', 'Torres del Paine']
    };

    const [comunasDisponibles, setComunasDisponibles] = useState([]);

    // Formulario
    const [formData, setFormData] = useState({
        rut: '',
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        email: '',
        telefono: '',
        direccion: '',
        comuna: '',
        region: '',
        fecha_ingreso: '',
        cargo: '',
        sueldo_base: '',
        afp: '',
        isapre_fonasa: '',
        // Nuevos campos
        sexo: '',
        nacionalidad: '',
        jornada: '',
        tipo_contrato: '',
        subsidio_joven: false,
        tipo_trabajador: 'ACTIVO',
        numero_cargas: 0,
        tramo_asignacion_familiar: '',
        gratificacion: '',
        pdf_url: ''
    });

    useEffect(() => {
        fetchColaboradores();
    }, [filtroEstado]);

    const fetchColaboradores = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}/api/rrhh/colaboradores`, {
                params: { id_company, estado: filtroEstado },
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                setColaboradores(response.data.data);
            }
        } catch (error) {
            console.error('Error al cargar colaboradores:', error);
            Swal.fire('Error', 'No se pudieron cargar los colaboradores', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const url = modoEdicion
                ? `${API_BASE_URL}/api/rrhh/colaboradores/${colaboradorActual.id}`
                : `${API_BASE_URL}/api/rrhh/colaboradores`;

            const method = modoEdicion ? 'put' : 'post';

            const response = await axios[method](url, {
                ...formData,
                id_company
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                const colaboradorCreado = response.data.data;

                // Si se creó un nuevo colaborador y hay un PDF cargado, guardarlo en BD
                // MODO HÍBRIDO: También crear registro en rrhh_contratos
                if (!modoEdicion && pdfOriginalFile) {
                    try {
                        const pdfFormData = new FormData();
                        pdfFormData.append('pdf', pdfOriginalFile);
                        pdfFormData.append('id_company', id_company);
                        pdfFormData.append('id_colaborador', colaboradorCreado.id);
                        pdfFormData.append('rut_colaborador', formData.rut);
                        pdfFormData.append('nombre_colaborador',
                            `${formData.nombres} ${formData.apellido_paterno} ${formData.apellido_materno || ''}`.trim()
                        );

                        // Campos para crear el contrato
                        pdfFormData.append('cargo', formData.cargo || '');
                        pdfFormData.append('tipo_contrato', formData.tipo_contrato || '');
                        pdfFormData.append('fecha_inicio', formData.fecha_ingreso || '');
                        pdfFormData.append('sueldo_base', formData.sueldo_base || '0');
                        pdfFormData.append('jornada', formData.jornada || 'COMPLETA');

                        // Flag para activar modo híbrido (crear contrato + guardar PDF)
                        pdfFormData.append('crear_contrato', 'true');

                        const uploadResponse = await axios.post(
                            `${API_BASE_URL}/api/rrhh/contratos/upload-pdf`,
                            pdfFormData,
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        );

                        if (uploadResponse.data.success && uploadResponse.data.data.contrato) {
                            console.log('✅ Contrato creado desde PDF externo:', uploadResponse.data.data.contrato.id);
                            console.log('✅ PDF del contrato guardado en BD');
                        } else {
                            console.log('✅ PDF del contrato guardado en BD (sin contrato asociado)');
                        }
                    } catch (pdfError) {
                        console.error('⚠️ Error al guardar PDF en BD:', pdfError);
                        // No fallar si falla el guardado del PDF
                    }
                }

                Swal.fire('Éxito', `Colaborador ${modoEdicion ? 'actualizado' : 'creado'} correctamente`, 'success');
                setShowModal(false);
                resetForm();
                setPdfOriginalFile(null); // Limpiar el PDF guardado
                fetchColaboradores();
            }
        } catch (error) {
            console.error('Error al guardar colaborador:', error);
            Swal.fire('Error', error.response?.data?.message || 'Error al guardar', 'error');
        }
    };

    // Función auxiliar para formatear fecha a YYYY-MM-DD (formato requerido por input type="date")
    const formatDateForInput = (dateValue) => {
        if (!dateValue) return '';
        try {
            const date = new Date(dateValue);
            if (isNaN(date.getTime())) return '';
            return date.toISOString().split('T')[0];
        } catch {
            return '';
        }
    };

    const handleEdit = (colaborador) => {
        setModoEdicion(true);
        setColaboradorActual(colaborador);

        // Si tiene región, cargar las comunas correspondientes
        if (colaborador.region && regionesComunas[colaborador.region]) {
            setComunasDisponibles(regionesComunas[colaborador.region]);
        }

        setFormData({
            rut: colaborador.rut || '',
            nombres: colaborador.nombres || '',
            apellido_paterno: colaborador.apellido_paterno || '',
            apellido_materno: colaborador.apellido_materno || '',
            email: colaborador.email || '',
            telefono: colaborador.telefono || '',
            direccion: colaborador.direccion || '',
            comuna: colaborador.comuna || '',
            region: colaborador.region || '',
            fecha_ingreso: formatDateForInput(colaborador.fecha_ingreso),
            cargo: colaborador.cargo || '',
            sueldo_base: colaborador.sueldo_base || '',
            afp: colaborador.afp || '',
            isapre_fonasa: colaborador.isapre_fonasa || '',
            // Nuevos campos
            sexo: colaborador.sexo || '',
            nacionalidad: colaborador.nacionalidad || '',
            jornada: colaborador.jornada || '',
            tipo_contrato: colaborador.tipo_contrato || '',
            subsidio_joven: colaborador.subsidio_joven || false,
            tipo_trabajador: colaborador.tipo_trabajador || 'ACTIVO',
            numero_cargas: colaborador.numero_cargas || 0,
            tramo_asignacion_familiar: colaborador.tramo_asignacion_familiar || '',
            gratificacion: colaborador.gratificacion || '',
            pdf_url: colaborador.pdf_url || ''
        });
        setShowModal(true);
    };

    const handleCambiarEstado = async (id, nuevoEstado) => {
        try {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: `Se cambiará el estado a ${nuevoEstado}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, cambiar',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                const response = await axios.patch(
                    `${API_BASE_URL}/api/rrhh/colaboradores/${id}/estado`,
                    { estado: nuevoEstado },
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (response.data.success) {
                    Swal.fire('Éxito', 'Estado actualizado', 'success');
                    fetchColaboradores();
                }
            }
        } catch (error) {
            console.error('Error al cambiar estado:', error);
            Swal.fire('Error', 'No se pudo cambiar el estado', 'error');
        }
    };

    const handleDelete = async (id, nombreCompleto) => {
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: `Se eliminará permanentemente a ${nombreCompleto} y todos sus registros relacionados (contratos, liquidaciones, finiquitos, licencias médicas). Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await colaboradoresService.deleteColaborador(id, id_company, token);
                Swal.fire('Eliminado', `${nombreCompleto} ha sido eliminado correctamente`, 'success');
                fetchColaboradores();
            } catch (error) {
                console.error('Error al eliminar colaborador:', error);
                Swal.fire('Error', error.message || 'Error al eliminar colaborador', 'error');
            }
        }
    };

    const resetForm = () => {
        setFormData({
            rut: '',
            nombres: '',
            apellido_paterno: '',
            apellido_materno: '',
            email: '',
            telefono: '',
            direccion: '',
            comuna: '',
            region: '',
            fecha_ingreso: '',
            cargo: '',
            sueldo_base: '',
            afp: '',
            isapre_fonasa: '',
            // Nuevos campos
            sexo: '',
            nacionalidad: '',
            jornada: '',
            tipo_contrato: '',
            subsidio_joven: false,
            tipo_trabajador: 'ACTIVO',
            numero_cargas: 0,
            tramo_asignacion_familiar: '',
            gratificacion: '',
            pdf_url: ''
        });
        setComunasDisponibles([]);
        setModoEdicion(false);
        setColaboradorActual(null);
        setPdfOriginalFile(null); // Limpiar PDF cargado
    };

    const handleCargarPdf = () => {
        pdfInputRef.current.click();
    };

    const handlePdfSelected = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== 'application/pdf') {
            Swal.fire('Error', 'El archivo debe ser un PDF', 'error');
            return;
        }

        // Guardar el PDF original para guardarlo después de crear el colaborador
        setPdfOriginalFile(file);

        try {
            setLoadingPdf(true);

            Swal.fire({
                title: 'Extrayendo datos del PDF...',
                html: 'Claude está analizando el documento. Esto puede tomar unos segundos.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const result = await colaboradoresService.extractFromPdf(file, id_company, token);

            Swal.close();

            if (result.success) {
                const fieldsCount = result.fieldsExtracted.length;
                const totalFields = result.fieldsExtracted.length + result.fieldsMissing.length;

                await Swal.fire({
                    title: 'Datos extraídos',
                    html: `
                        <p><strong>${fieldsCount} de ${totalFields} campos</strong> fueron extraídos del PDF.</p>
                        <p class="text-muted" style="font-size: 14px; margin-top: 10px;">
                            Los campos faltantes quedarán en blanco para que los completes manualmente.
                        </p>
                    `,
                    icon: 'success',
                    confirmButtonText: 'Continuar'
                });

                const extractedData = result.data;

                // Si hay región, cargar comunas
                if (extractedData.region && regionesComunas[extractedData.region]) {
                    setComunasDisponibles(regionesComunas[extractedData.region]);
                }

                // Mapear sexo M/F → Masculino/Femenino
                let sexoMapeado = extractedData.sexo || '';
                if (sexoMapeado === 'M') sexoMapeado = 'Masculino';
                if (sexoMapeado === 'F') sexoMapeado = 'Femenino';

                // Actualizar formulario con todos los campos extraídos
                setFormData(prev => ({
                    ...prev,
                    rut: extractedData.rut || '',
                    nombres: extractedData.nombres || '',
                    apellido_paterno: extractedData.apellido_paterno || '',
                    apellido_materno: extractedData.apellido_materno || '',
                    email: extractedData.email || '',
                    telefono: extractedData.telefono || '',
                    direccion: extractedData.direccion || '',
                    comuna: extractedData.comuna || '',
                    region: extractedData.region || '',
                    fecha_ingreso: extractedData.fecha_ingreso || '',
                    cargo: extractedData.cargo || '',
                    sueldo_base: extractedData.sueldo_base || '',
                    afp: extractedData.afp || '',
                    isapre_fonasa: extractedData.isapre_fonasa || '',
                    sexo: sexoMapeado,
                    nacionalidad: extractedData.nacionalidad || '',
                    jornada: extractedData.jornada || '',
                    tipo_contrato: extractedData.tipo_contrato || '',
                    subsidio_joven: extractedData.subsidio_joven || false,
                    tipo_trabajador: extractedData.tipo_trabajador || 'ACTIVO',
                    numero_cargas: extractedData.numero_cargas || 0,
                    tramo_asignacion_familiar: extractedData.tramo_asignacion_familiar || '',
                    gratificacion: extractedData.gratificacion || '',
                    pdf_url: extractedData.pdf_url || ''
                }));

                setShowModal(true);

            } else {
                Swal.fire('Error', result.message || 'No se pudo extraer datos del PDF', 'error');
            }

        } catch (error) {
            console.error('Error al procesar PDF:', error);
            Swal.fire('Error', error.message || 'Error al procesar el PDF', 'error');
        } finally {
            setLoadingPdf(false);
            e.target.value = '';
        }
    };

    return (
        <div className="colaboradores-container">
            <div className="colaboradores-header">
                <h1>Gestión de Colaboradores</h1>
                <div className="header-buttons">
                    <button
                        className="btn-secondary"
                        onClick={handleCargarPdf}
                        title="Cargar datos desde PDF (CV, Contrato, etc.) usando IA"
                    >
                        <FaPlus /> Cargar desde PDF
                    </button>
                    <button className="btn-nuevo" onClick={() => { resetForm(); setShowModal(true); }}>
                        <FaPlus /> Nuevo Colaborador
                    </button>
                    {/* Input file oculto para PDFs */}
                    <input
                        type="file"
                        ref={pdfInputRef}
                        accept="application/pdf"
                        onChange={handlePdfSelected}
                        style={{ display: 'none' }}
                    />
                </div>
            </div>

            {/* Filtro */}
            <div className="colaboradores-filters">
                <select value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                    <option value="">Todos</option>
                    <option value="ACTIVO">Activos</option>
                    <option value="INACTIVO">Inactivos</option>
                    <option value="SUSPENDIDO">Suspendidos</option>
                </select>
            </div>

            {/* Tabla de colaboradores */}
            {loading ? (
                <div className="loading">Cargando colaboradores...</div>
            ) : (
                <div className="colaboradores-table-container">
                    <table className="colaboradores-table">
                        <thead>
                            <tr>
                                <th>RUT</th>
                                <th>Nombre Completo</th>
                                <th>Cargo</th>
                                <th>Fecha Ingreso</th>
                                <th>Sueldo Base</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {colaboradores.length === 0 ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '30px' }}>
                                        No se encontraron colaboradores
                                    </td>
                                </tr>
                            ) : (
                                colaboradores.map((col) => (
                                    <tr key={col.id}>
                                        <td>{col.rut}</td>
                                        <td>{`${col.nombres} ${col.apellido_paterno} ${col.apellido_materno || ''}`}</td>
                                        <td>{col.cargo}</td>
                                        <td>{new Date(col.fecha_ingreso).toLocaleDateString('es-CL')}</td>
                                        <td>${parseInt(col.sueldo_base).toLocaleString('es-CL')}</td>
                                        <td>
                                            <span className={`badge badge-${col.estado.toLowerCase()}`}>
                                                {col.estado}
                                            </span>
                                        </td>
                                        <td className="actions-cell">
                                            <button className="btn-edit" onClick={() => handleEdit(col)} title="Editar">
                                                <FaEdit />
                                            </button>
                                            {col.estado === 'ACTIVO' ? (
                                                <button
                                                    className="btn-inactivar"
                                                    onClick={() => handleCambiarEstado(col.id, 'INACTIVO')}
                                                    title="Inactivar"
                                                >
                                                    <FaUserTimes />
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn-activar"
                                                    onClick={() => handleCambiarEstado(col.id, 'ACTIVO')}
                                                    title="Activar"
                                                >
                                                    <FaUserCheck />
                                                </button>
                                            )}
                                            <button
                                                className="btn-delete"
                                                onClick={() => handleDelete(col.id, `${col.nombres} ${col.apellido_paterno} ${col.apellido_materno || ''}`.trim())}
                                                title="Eliminar"
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Modal de formulario */}
            {showModal && (
                <div className="modal-overlay" onClick={() => { setShowModal(false); resetForm(); }}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h2>{modoEdicion ? 'Editar Colaborador' : 'Nuevo Colaborador'}</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-grid">
                                <div className="form-group">
                                    <label>RUT *</label>
                                    <input
                                        type="text"
                                        value={formData.rut}
                                        onChange={(e) => setFormData({...formData, rut: e.target.value})}
                                        required
                                        disabled={modoEdicion}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Nombres *</label>
                                    <input
                                        type="text"
                                        value={formData.nombres}
                                        onChange={(e) => setFormData({...formData, nombres: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Apellido Paterno *</label>
                                    <input
                                        type="text"
                                        value={formData.apellido_paterno}
                                        onChange={(e) => setFormData({...formData, apellido_paterno: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Apellido Materno</label>
                                    <input
                                        type="text"
                                        value={formData.apellido_materno}
                                        onChange={(e) => setFormData({...formData, apellido_materno: e.target.value})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        type="email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Teléfono</label>
                                    <input
                                        type="text"
                                        value={formData.telefono}
                                        onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Dirección</label>
                                    <input
                                        type="text"
                                        value={formData.direccion}
                                        onChange={(e) => setFormData({...formData, direccion: e.target.value})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Región</label>
                                    <select
                                        value={formData.region}
                                        onChange={(e) => {
                                            const nuevaRegion = e.target.value;
                                            setFormData({...formData, region: nuevaRegion, comuna: ''});
                                            setComunasDisponibles(regionesComunas[nuevaRegion] || []);
                                        }}
                                    >
                                        <option value="">Seleccionar región...</option>
                                        {Object.keys(regionesComunas).map(region => (
                                            <option key={region} value={region}>{region}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Comuna</label>
                                    <select
                                        value={formData.comuna}
                                        onChange={(e) => setFormData({...formData, comuna: e.target.value})}
                                        disabled={!formData.region}
                                    >
                                        <option value="">Seleccionar comuna...</option>
                                        {comunasDisponibles.map(comuna => (
                                            <option key={comuna} value={comuna}>{comuna}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Cargo *</label>
                                    <input
                                        type="text"
                                        value={formData.cargo}
                                        onChange={(e) => setFormData({...formData, cargo: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Fecha Ingreso *</label>
                                    <input
                                        type="date"
                                        value={formData.fecha_ingreso}
                                        onChange={(e) => setFormData({...formData, fecha_ingreso: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Sueldo Base *</label>
                                    <input
                                        type="number"
                                        value={formData.sueldo_base}
                                        onChange={(e) => setFormData({...formData, sueldo_base: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>AFP</label>
                                    <select
                                        value={formData.afp}
                                        onChange={(e) => setFormData({...formData, afp: e.target.value})}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="CAPITAL">AFP Capital</option>
                                        <option value="CUPRUM">AFP Cuprum</option>
                                        <option value="HABITAT">AFP Habitat</option>
                                        <option value="PLANVITAL">AFP PlanVital</option>
                                        <option value="PROVIDA">AFP Provida</option>
                                        <option value="MODELO">AFP Modelo</option>
                                        <option value="UNO">AFP UNO</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Salud (Isapre/Fonasa)</label>
                                    <select
                                        value={formData.isapre_fonasa}
                                        onChange={(e) => setFormData({...formData, isapre_fonasa: e.target.value})}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="FONASA">Fonasa</option>
                                        <option value="BANMEDICA">Isapre Banmédica</option>
                                        <option value="COLMENA">Isapre Colmena</option>
                                        <option value="CONSALUD">Isapre Consalud</option>
                                        <option value="CRUZ_BLANCA">Isapre Cruz Blanca</option>
                                        <option value="NUEVA_MASVIDA">Isapre Nueva MasVida</option>
                                        <option value="VIDA_TRES">Isapre Vida Tres</option>
                                    </select>
                                </div>

                                {/* Nuevos campos */}
                                <div className="form-group">
                                    <label>Sexo</label>
                                    <select
                                        value={formData.sexo}
                                        onChange={(e) => setFormData({...formData, sexo: e.target.value})}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="M">Masculino</option>
                                        <option value="F">Femenino</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Nacionalidad</label>
                                    <select
                                        value={formData.nacionalidad}
                                        onChange={(e) => setFormData({...formData, nacionalidad: e.target.value})}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="CHILENA">Chilena</option>
                                        <option value="EXTRANJERA">Extranjera</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Tipo de Contrato</label>
                                    <select
                                        value={formData.tipo_contrato}
                                        onChange={(e) => setFormData({...formData, tipo_contrato: e.target.value})}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="INDEFINIDO">Indefinido</option>
                                        <option value="PLAZO_FIJO">Plazo Fijo</option>
                                        <option value="OBRA_FAENA">Por Obra o Faena</option>
                                        <option value="HONORARIOS">Honorarios</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Jornada</label>
                                    <select
                                        value={formData.jornada}
                                        onChange={(e) => setFormData({...formData, jornada: e.target.value})}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="COMPLETA">Completa</option>
                                        <option value="PARCIAL">Parcial</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Tipo de Trabajador</label>
                                    <select
                                        value={formData.tipo_trabajador}
                                        onChange={(e) => setFormData({...formData, tipo_trabajador: e.target.value})}
                                    >
                                        <option value="ACTIVO">Activo</option>
                                        <option value="PENSIONADO">Pensionado</option>
                                        <option value="SUBSIDIADO">Subsidiado</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Número de Cargas</label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={formData.numero_cargas}
                                        onChange={(e) => setFormData({...formData, numero_cargas: e.target.value})}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Tramo Asignación Familiar</label>
                                    <select
                                        value={formData.tramo_asignacion_familiar}
                                        onChange={(e) => setFormData({...formData, tramo_asignacion_familiar: e.target.value})}
                                    >
                                        <option value="">Sin tramo</option>
                                        <option value="A">Tramo A</option>
                                        <option value="B">Tramo B</option>
                                        <option value="C">Tramo C</option>
                                        <option value="D">Tramo D</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Gratificación</label>
                                    <select
                                        value={formData.gratificacion}
                                        onChange={(e) => setFormData({...formData, gratificacion: e.target.value})}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="articulo 47">Artículo 47</option>
                                        <option value="articulo 50">Artículo 50</option>
                                    </select>
                                </div>

                                <div className="form-group" style={{gridColumn: '1 / -1'}}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={formData.subsidio_joven}
                                            onChange={(e) => setFormData({...formData, subsidio_joven: e.target.checked})}
                                        />
                                        {' '}Subsidio Joven
                                    </label>
                                </div>
                            </div>

                            <div className="modal-actions">
                                <button type="button" className="btn-cancel" onClick={() => { setShowModal(false); resetForm(); }}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn-save">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ColaboradoresPage;
